import { render, staticRenderFns } from "./SearchBAF.vue?vue&type=template&id=0fcd557c&"
import script from "./SearchBAF.vue?vue&type=script&lang=js&"
export * from "./SearchBAF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports